import SEO from '../components/SEO';
import PageLayout from '../components/PageLayout';
import LeadForm from '../components/LeadForm';
import { SITE, ZONES } from '../lib/site';
import { Phone, Mail, Clock, MapPin } from 'lucide-react';

const Contacto = () => {
  return (
    <PageLayout
      label="Contacto"
      title="Hablemos de tu"
      titleEm="proyecto"
      lead="Cuéntanos qué necesitas por WhatsApp, teléfono o formulario. Te respondemos en menos de 24 horas laborables, siempre una persona real."
      crumbs={[{ name: 'Contacto' }]}
    >
      <SEO
        title="Contacto — HGO Servicios · Reformas y Construcción en Málaga"
        description="Contacta con HGO Servicios: teléfono +34 643 67 08 32, WhatsApp o email. Presupuesto gratis en 24h para reformas y obras en Málaga y la Costa del Sol."
        url="/contacto"
        breadcrumbs={[{ name: 'Inicio', url: '/' }, { name: 'Contacto', url: '/contacto' }]}
      />

      <section className="max-w-[1400px] mx-auto px-6 py-16 md:py-24">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-14 lg:gap-20">
          {/* Datos de contacto */}
          <div className="space-y-5">
            {[
              { icon: Phone, label: 'Teléfono', value: SITE.phoneDisplay, href: `tel:${SITE.phone}`, sub: 'Lun–Vie 9:00 a 18:00' },
              { icon: Mail, label: 'Email', value: SITE.email, href: `mailto:${SITE.email}`, sub: 'Respondemos en 24h' },
              { icon: Clock, label: 'Horario', value: SITE.hours, sub: 'Emergencias de obra: consulta' },
              { icon: MapPin, label: 'Cobertura', value: 'Málaga capital + Costa del Sol', sub: 'Equipos de la provincia' },
            ].map((c, i) => (
              <a
                key={i}
                href={c.href ?? '#'}
                className="reveal group flex items-center gap-5 bg-paper-2 border border-line rounded-[4px] p-6 hover:border-clay/60 transition-colors duration-200"
              >
                <span className="grid place-items-center w-12 h-12 rounded-full bg-ink text-clay-light shrink-0 group-hover:scale-105 transition-transform duration-200">
                  <c.icon size={20} />
                </span>
                <div>
                  <p className="text-[0.65rem] font-bold uppercase tracking-[0.18em] text-ink-faint">{c.label}</p>
                  <p className="font-display font-bold tracking-tight mt-0.5">{c.value}</p>
                  <p className="text-xs text-ink-faint mt-0.5">{c.sub}</p>
                </div>
              </a>
            ))}

            <div className="reveal bg-ink text-paper rounded-[4px] p-7">
              <h2 className="font-display font-bold uppercase tracking-tight text-base">Zonas de servicio</h2>
              <div className="mt-4 flex flex-wrap gap-2">
                {ZONES.map((z) => (
                  <span key={z.slug} className="text-[0.7rem] font-semibold text-paper/70 bg-paper/8 border border-paper/15 rounded-full px-3 py-1.5">
                    {z.name}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Formulario */}
          <div className="reveal">
            <LeadForm
              title="Escríbenos"
              subtitle="Rellena el formulario y te abrimos WhatsApp con tu mensaje listo para enviar."
            />
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default Contacto;
